import Translatable from '@/components/translatable_text/Translatable';
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Stack,
} from '@mui/material';
import { TraineeProps, TableHeadListProps } from '@/types/admin_types';
import TraineeRow from './TraineeRow';

const tableHeadList = [
  { id: 231, title: '#', color: '', width: 10 },
  { id: 232, title: 'Name', color: '', width: 150 },
  { id: 233, title: 'Email', color: '', width: 150 },
  { id: 234, title: 'Institution', color: '', width: 150 },
  { id: 236, title: 'Action', color: '', width: 150 },
]

type Props = {
  data: any;
}

export default function TraineesTable({ data }: Props) {

  return (
    <div className='border rounded-md'>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {tableHeadList.map((elList: TableHeadListProps) => (
                <TableCell key={elList.id} width={elList.width}>
                  <Stack spacing={2} direction="row">
                    <Typography variant="h6" color='#64758b' fontSize={16}>
                      <Translatable>
                        {elList.title}
                      </Translatable>
                    </Typography>
                  </Stack>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((el: TraineeProps, index: number) => (
              <TraineeRow el={el} key={index} index={index}/>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>

  )
}
